import { CUIFlex, CUISpacer } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CheckUsernameAvailable from './ClaimUsername/CheckUsernameAvailable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmphasisText = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CUIBox, {
    display: "inline",
    sx: {
      textDecoration: 'underline',
      textDecorationColor: 'SOLARIS.medium',
      textDecorationThickness: {
        base: '2px',
        md: '4px'
      },
      textUnderlineOffset: {
        base: '5px',
        md: '8px'
      }
    },
    children: children
  });
};
const HomepageHeaderContent = () => {
  return /*#__PURE__*/_jsxs(CUIFlex, {
    direction: "column",
    height: "100%",
    width: "100%",
    align: "center",
    textAlign: "center",
    gap: 6,
    children: [/*#__PURE__*/_jsxs(CUIBox, {
      maxWidth: "1000px",
      children: [/*#__PURE__*/_jsx(CUIHeading, {
        as: "h1",
        variant: "taglineHeading",
        lineHeight: "1.2 !important",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "app.homepage.header.heading_jsx",
          elements: {
            Highlight: EmphasisText
          }
        })
      }), /*#__PURE__*/_jsx(CUISpacer, {})]
    }), /*#__PURE__*/_jsx(CUIText, {
      fontSize: "lg",
      maxWidth: "700px",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.header.bodyText"
      })
    }), /*#__PURE__*/_jsx(CheckUsernameAvailable, {})]
  });
};
export default HomepageHeaderContent;